export default function( nodes, img = 'img', position = 'center' ) {
	console.log( nodes );
	if ( typeof nodes === 'string' ) {
		nodes = Array.from( document.querySelectorAll( nodes ) );
	}

	console.log( nodes );

	if ( ! nodes.length ) {
		return;
	}

	for ( let i = 0, nodesLength = nodes.length; i < nodesLength; i++ ) {
		let imgNode = nodes[i].querySelector( img );

		console.log( nodes[i], imgNode );

		if ( ! imgNode ) {
			continue;
		}

		nodes[i].style.backgroundPosition = position;
		nodes[i].style.backgroundSize = 'cover';
		nodes[i].style.backgroundImage = `url(${imgNode.currentSrc || imgNode.src})`;
		imgNode.style.display = 'none';
	}
}
